/** Text input that commits on Enter/blur and cancels on Escape. */
import React from "react";

const CommitInput: React.FC<{
  className?: string;
  initial: string;
  onCommit: (value: string) => void;
  onCancel: () => void;
}> = ({ className, initial, onCommit, onCancel }) => {
  const [value, setValue] = React.useState(initial);
  const committedRef = React.useRef(false);
  const commit = () => {
    if (committedRef.current) return;
    committedRef.current = true;
    onCommit(value);
  };
  return (
    <input
      className={className}
      autoFocus
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit();
        else if (e.key === "Escape") {
          committedRef.current = true;
          onCancel();
        }
      }}
    />
  );
};

export default CommitInput;
